import useFilters from "./useFilters";
import TokenInput from "../../../components/TokenInput";

export default function NameFilter() {
    const [filters, set] = useFilters();
    return (
        <TokenInput
            label="search Products by name"
            onChange={ (token) => set("token", token) }
            value={ filters.token }
        />
    );
}
